import { PropsWithChildren } from 'react'
import bgLayout from '../../../asserts/background/bgLight.png'

const LightLayout = (props: PropsWithChildren) => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        backgroundImage: `url("${bgLayout}")`,
        backgroundRepeat: 'repeat',
        backgroundSize: 'cover',
        borderRadius: '15px',
      }}
    >
      {props.children}
    </div>
  )
}

export default LightLayout
